module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat2-6aa63a4a9dfb1b9b779746b00a7424c3.svg";